export const Materials = {
    MetalBright: 'metalBright',
    MetalBlackEtch: 'metalBlackEtch',
    Wood: 'wood',
    MetalSatin: 'metalSatin',
    MetalMirrorPolish: 'metalMirrorPolish',
    BlackAlu: 'aluminiumBlack'
};

//# sourceMappingURL=materials.js.map